export { getElementIsTab } from './detection';
